import { render, staticRenderFns } from "./ArtistPictureManager.vue?vue&type=template&id=1a41b255&scoped=true&"
import script from "./ArtistPictureManager.vue?vue&type=script&lang=js&"
export * from "./ArtistPictureManager.vue?vue&type=script&lang=js&"
import style0 from "./ArtistPictureManager.vue?vue&type=style&index=0&id=1a41b255&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a41b255",
  null
  
)

export default component.exports